(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-vianne-quantity-choice]:not([data-vianne-quantity-ready])').forEach((root) => {
      const form = root.closest('form');
      const input = form?.querySelector('.js-quantity-input');
      if (!input) return;

      const count = root.querySelector('[data-vianne-quantity-count]');
      const servings = root.querySelector('[data-vianne-quantity-servings]');
      const total = root.querySelector('[data-vianne-quantity-total]');
      const shipping = root.querySelector('[data-vianne-shipping]');
      const shippingMessage = shipping?.querySelector('[data-vianne-shipping-message]');
      const unitPrice = () => Number(root.closest('[data-cm-product-layout]')?.querySelector('.product__prices [data-vianne-price]')?.dataset.basePrice || root.dataset.unitPrice);
      const servingsPerPouch = Number(root.dataset.servingsPerPouch);
      const shippingThreshold = Number(root.dataset.shippingThreshold);
      const shippingFee = Number(root.dataset.shippingFee);
      const country = root.dataset.country;
      const currency = root.dataset.currency || window.Shopify?.currency?.active || 'EUR';
      const locale = root.dataset.locale || document.documentElement.lang || 'en';

      let formatter;
      try {
        formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
      } catch {
        formatter = new Intl.NumberFormat('en', { style: 'currency', currency: 'EUR' });
      }

      const formatMoney = (amount) => {
        const moneyFormat = root.dataset.moneyFormat || window.theme_variables?.settings?.money_format;
        if (moneyFormat && typeof window.SHTHelper?.formatMoney === 'function') {
          const decoded = document.createElement('textarea');
          decoded.innerHTML = window.SHTHelper.formatMoney(Math.round(amount), moneyFormat);
          return decoded.value;
        }
        return formatter.format(amount / 100);
      };

      const updateSummary = (amount) => {
        const quantity = Math.max(1, Number.parseInt(form.querySelector('.js-quantity-input')?.value, 10) || 1);
        // Same delivery rule as the per-dose line: the fee applies below the
        // threshold, tested on the goods only, so the fee never pushes the
        // displayed order over the free-shipping limit. France only.
        const withDelivery = country === 'FR' && shippingFee > 0 && amount < shippingThreshold;
        if (shippingMessage) shippingMessage.textContent = amount >= shippingThreshold ? shipping.dataset.shippingEarned : shipping.dataset.shippingOffer;
        const pouchLabel = quantity === 1 ? root.dataset.pouchOne : root.dataset.pouchMany;
        if (count) count.textContent = quantity + ' ' + pouchLabel;
        if (servings && servingsPerPouch > 0) servings.textContent = quantity * servingsPerPouch + ' ' + root.dataset.servingsLabel;
        const note = withDelivery && root.dataset.shippingNote ? ' ' + root.dataset.shippingNote.replace('[amount]', formatMoney(shippingFee)) : '';
        if (total) total.textContent = root.dataset.totalLabel + ' ' + formatMoney(amount + (withDelivery ? shippingFee : 0)) + note;
      };

      const update = () => {
        const startedAt = window.performance?.now?.() ?? Date.now();
        updateSummary(unitPrice() * Math.max(1, Number.parseInt(form.querySelector('.js-quantity-input')?.value, 10) || 1));
        const completedAt = window.performance?.now?.() ?? Date.now();
        root.dataset.vianneFeedbackMs = Math.max(0, completedAt - startedAt).toFixed(2);
      };
      const onChange = event => {
        if (event.target.matches('.js-quantity-input, [name="id"]')) update();
      };
      form.addEventListener('input', onChange, true);
      form.addEventListener('change', onChange, true);
      root.dataset.vianneQuantityReady = 'true';
      update();
      window.ViannePriceDisplay?.initialize(root, formatMoney, updateSummary);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
